export var theme = {
  colors: {
    background: '#ffffff',
    border: '#c7dae8',
    dark: '#454545',
    transparentBackground: 'rgba(255, 255, 255, .56)'
  }
};